import Header from "../components/home/Header";
import ProjectSection from "../components/home/ProjectSection";
import Footer from "../components/shared/Footer";

function Homepage() {
  return (
    <>
      <Header />
      <ProjectSection />
    </>
  );
}

export default Homepage;
